import axios from "axios";
import { urlAPI } from "../../config/config";
import { showSnackbar } from "../../redux/actions";
import { IForecastSalaryFormValues } from "../../interface/salariesForecast";

export const addUpdateSalaries = async (
    token: string,
    values: IForecastSalaryFormValues,
    forecastId: string,
    version: number,
    setOpenModal: Function,
    dispatch: Function,
    setError: Function,
    salaryId? : string
) => {
    try {
        if(!salaryId){
          const response = await axios.post(`${urlAPI}/forecast/salaries/add`,
            { ...values, forecastId, forecastVersion: version },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
        } 
        else{
          const response = await axios.post(`${urlAPI}/forecast/salaries/update/${salaryId}`,
            { ...values, forecastId, forecastVersion: version },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
        }       
        setOpenModal(false);
        dispatch(showSnackbar("Salarié enregistré avec succès.", "success"));
      } catch (error: any) {
        if (error.response) {
          console.error("Erreur API :", error.response.data);
          console.error("Statut :", error.response.status);
        } else if (error.request) {
          console.error("Erreur de requête :", error.request);
        } else {
          console.error("Erreur :", error.message);
        }
  
        setError("Impossible d'enregistrer l'épargne'. Veuillez réessayer.");
        dispatch(showSnackbar("Erreur lors de l'enregistrement.", "error"));
      }
};
